import React from 'react';

/**
 * Component To Display Label based on options provided.
 */
const InputLabel = (name: string, isMandatory?: boolean): React.ReactElement => {
  return (
    <label className="form-label grey--text">
      <span className="text-bold">{name} </span>
      {isMandatory ? (
        <span className="font-weight-bold color-red">*</span>
      ) : (
        <span className="secondary-text">(optional)</span>
      )}
    </label>
  );
};

export default InputLabel;
